if (!customElements.get('cart-vat-number-field')) {
  customElements.define(
    'cart-vat-number-field',
    class extends HTMLElement {
      connectedCallback() {
        var input = this.querySelector('input');
        var error = this.querySelector('.cart-vat-number__error');
        if (!input || !error || input.dataset.vatBound) return;
        input.dataset.vatBound = 'true';

        var updateUrl = this.dataset.updateUrl;

        var isValid = function (raw) {
          var normalized = raw.replace(/[\s.]/g, '').toUpperCase();
          if (normalized === '') return true;
          return /^BE[01]\d{9}$/.test(normalized);
        };

        var validate = function () {
          var valid = isValid(input.value);
          error.hidden = valid;
          input.classList.toggle('cart-vat-number__input--invalid', !valid);
          input.setAttribute('aria-invalid', valid ? 'false' : 'true');
          return valid;
        };

        var syncToCart = function () {
          if (!updateUrl) return;
          fetch(updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'VAT Registration Number': input.value } })
          }).catch(function () {});
        };

        var handleCommit = function () {
          if (validate()) syncToCart();
        };

        // "change" alone covers "the shopper left the field after editing it" —
        // it only fires when the value actually changed, unlike "blur" which
        // fires regardless. Listening to both caused two identical, redundant
        // cart updates for a single edit.
        input.addEventListener('change', handleCommit);
        input.addEventListener('input', function () {
          if (!error.hidden) validate();
        });
      }
    }
  );
}
